import { Box, Button, Container, Stack, Typography } from "@mui/material";
import React from "react";
import { WhatsAppContact } from "../../../utils/common";

const solutionsData = [
  {
    title: "ONLINE DOCTOR CONSULTATION",
    description:
      "Skip the waiting rooms! Connect with experienced doctors from the comfort of your home. Our online doctor consultations are quick, secure, and designed to give you expert medical advice when you need it most.",
    buttonText: "BOOK CONSULTATION",
    image: "/websiteAssets/LandingPageDoctorConsultant.png",
    imagePosition: "right",
    whatsappMessage:
      "Hello, I would like to book an online doctor consultation. Please guide me with the next steps.",
  },
  {
    title: "HOME NURSING",
    description:
      "Professional nursing care brought to your doorstep. Whether it’s post-surgical care, elderly support, or chronic condition management, our licensed nurses provide compassionate, high-quality care in the comfort of your home.",
    buttonText: "BOOK CONSULTATION",
    image: "/websiteAssets/LandingPageHomeNursing.png",
    imagePosition: "left",
    whatsappMessage:
      "Hello, I want to avail Home Care Service. Kindly share details and availability.",
  },
  {
    title: "ONLINE MEDICAL CONSULTATION",
    description:
      "Talk to certified specialists without stepping out. Get personalized medical advice, prescriptions, and follow-ups through our secure online platform – accessible anytime, anywhere.",
    buttonText: "BOOK CONSULTATION",
    image: "/websiteAssets/SolutionOverviewImage.png",
    imagePosition: "right",
    whatsappMessage:
      "Hello, I would like to schedule an online medical consultation. Please assist me.",
  },
  {
    title: "ONLINE MEDICINE DELIVERY",
    description:
      "Get your medicines delivered fast and hassle-free. Order online and receive genuine, prescribed medications at your doorstep, ensuring you never miss a dose.",
    buttonText: "BOOK CONSULTATION",
    image: "/websiteAssets/LandingPageMedicineDelivery.png",
    imagePosition: "left",
    whatsappMessage:
      "Hello, I would like to order medicines online. Please let me know the process.",
  },
];

const SolutionCard = ({
  title,
  description,
  buttonText,
  image,
  imagePosition,
  whatsappMessage,
}) => {
  const handleConsultancyClick = () => {
    WhatsAppContact(whatsappMessage);
  };

  const content = (
    <Stack
      spacing={{ xs: 2, md: 3 }}
      width={{ xs: "100%", md: "450px" }}
      maxWidth={{ xs: "100%", md: "450px" }}
      textAlign={{ xs: "center", md: "left" }}
    >
      <Typography
        variant="h2"
        sx={{
          fontFamily: "'Jost-Bold', Montserrat",
          fontSize: { xs: 28, sm: 34, md: 48 },
          fontWeight: 700,
          lineHeight: { xs: "36px", md: "50px" },
          color: "primary.main",
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontFamily: "'Satoshi-Medium', Montserrat",
          fontSize: { xs: 14, sm: 15, md: 16 },
          fontWeight: 500,
          color: "#191d23",
          pr:
            title === "ONLINE DOCTOR CONSULTATION" && imagePosition !== "left"
              ? { md: "48px" }
              : 0,
          lineHeight: 1.7,
        }}
      >
        {description}
      </Typography>

      <Button
        variant="contained"
        onClick={() => {
          handleConsultancyClick();
        }}
        sx={{
          width: { xs: "100%", sm: "fit-content" },
          minWidth: { xs: "100%", sm: 220 },
          height: { xs: 48, md: 55 },
          borderRadius: "10px",
          backgroundColor: "primary.main",
          fontFamily: "'Istok_Web-Bold', Montserrat",
          fontWeight: 700,
          fontSize: { xs: 14, md: 16 },
          textAlign: "center",
          alignSelf: { xs: "center", md: "flex-start" },
        }}
      >
        {title === "ONLINE DOCTOR CONSULTATION" ||
        title === "ONLINE MEDICAL CONSULTATION"
          ? "BOOK CONSULTATION"
          : title === "ONLINE MEDICINE DELIVERY"
          ? "ORDER NOW"
          : title === "HOME NURSING"
          ? "GET IN TOUCH"
          : "LEARN MORE"}
      </Button>
    </Stack>
  );

  const imageElement = (
    <Box
      component="img"
      src={image}
      alt={title}
      sx={{
        width: { xs: "100%", sm: "85%", md: "600px" },
        height: { xs: 220, sm: 280, md: 400 },
        objectFit: "cover",
        borderRadius: { xs: "16px", md: "24px" },
        mx: "auto",
      }}
    />
  );

  return (
    <Stack
      direction={{
        xs: "column",
        md: "row",
      }}
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      spacing={{ xs: 3.5, md: 6 }}
    >
      {imagePosition === "left" ? imageElement : content}
      {imagePosition === "left" ? content : imageElement}
    </Stack>
  );
};

const SolutionsOverviewSection = () => {
  return (
    <Box
      component="section"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: { xs: 6, md: 8 },
        bgcolor: "background.paper",
        position: "relative",
        px: { xs: 2, md: 0 },
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: { xs: 2.5, md: "25px" },
          mb: { xs: 4, md: "50px" },
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontFamily: "'Jost-Bold', Montserrat",
            fontSize: { xs: 36, sm: 44, md: 64 },
            fontWeight: 700,
            lineHeight: { xs: "44px", md: "50px" },
            color: "primary.main",
            textAlign: "center",
          }}
        >
          OUR SOLUTIONS
        </Typography>

        <Typography
          sx={{
            fontFamily: "'Poppins-Light', Montserrat",
            fontSize: { xs: 14, sm: 16, md: 20 },
            fontWeight: 300,
            letterSpacing: "-0.32px",
            textAlign: "center",
            color: "black",
            lineHeight: 1.7,
          }}
        >
          Our mission is to empower individuals by providing a secure platform
          to manage personal records and share profiles effortlessly with a
          single tap. We are committed to enhancing connectivity and simplifying
          access to essential information, making everyday interactions seamless
          and efficient.
        </Typography>
      </Container>

      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            display: { xs: "none", md: "block" },
            width: "215px",
            top: 0,
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            bgcolor: "primary.main",
            borderRadius: "10px",
            zIndex: 0,
          }}
        />

        <Container
          maxWidth="lg"
          sx={{ position: "relative", zIndex: 1, px: { xs: 0, sm: 2 } }}
        >
          <Stack spacing={{ xs: 4, md: 6 }} py={{ xs: 4, md: 6 }}>
            {solutionsData.map((solution, index) => (
              <SolutionCard
                key={index}
                title={solution.title}
                description={solution.description}
                buttonText={solution.buttonText}
                image={solution.image}
                imagePosition={solution.imagePosition}
                whatsappMessage={solution.whatsappMessage}
              />
            ))}
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default SolutionsOverviewSection;
